import { Skeleton } from "@/components/ui/skeleton"

export function PageLoading() {
  return (
    <main className="min-h-svh bg-[var(--cloud)] p-4 sm:p-6 lg:p-8">
      <div className="mx-auto max-w-[1400px]">
        <Skeleton className="h-16 w-full rounded-[14px]" />
        <div className="mt-6 grid gap-6 lg:grid-cols-[220px_1fr]">
          <Skeleton className="hidden min-h-[640px] rounded-[14px] lg:block" />
          <div className="space-y-4">
            <Skeleton className="h-16 w-2/3 rounded-[14px]" />
            <Skeleton className="h-36 w-full rounded-[14px]" />
            <Skeleton className="h-80 w-full rounded-[14px]" />
          </div>
        </div>
      </div>
    </main>
  )
}
